<div class="website-content">
  <header class="website-content__nav">
    <a class="website-content__brand" [routerLink]="mktPath.home()" [attr.aria-label]="brandWordmark">
      <img [src]="brandLogoSrc" [alt]="brandWordmark" width="120" height="32" />
    </a>
    <a class="website-content__back" [routerLink]="mktPath.home()">{{ 'website.content.backHome' | translate }}</a>
  </header>

  <main class="website-content__main">
    <h1>{{ i18nPrefix() + '.heroTitle' | translate }}</h1>
    <p class="website-content__sub">{{ i18nPrefix() + '.heroSub' | translate }}</p>

    @for (key of bodyParagraphKeys; track key) {
      @if ((i18nPrefix() + '.body.' + key | translate) !== i18nPrefix() + '.body.' + key) {
        <p>{{ i18nPrefix() + '.body.' + key | translate }}</p>
      }
    }

    @if ((i18nPrefix() + '.cta' | translate) !== i18nPrefix() + '.cta') {
      <a class="website-content__cta" [href]="registerUrl">{{ i18nPrefix() + '.cta' | translate }}</a>
    }
  </main>
</div>
